// Client-facing status labels — spec §5.
//
// The customer sees the 5-step frieze:
//   Pickup scheduled → Picked up → In progress → On the way back → Delivered
// Internal statuses never leak. Payment is a badge, not a step:
// PAYMENT DUE (gold) vs PAID (green). Once paid the frieze STAYS on
// "In progress" — the workflow only advances when the admin ships.
//
// PAYMENT_LINK is a placeholder for the future Pay-now button. When we
// wire Stripe we flip it to true; today it just reserves the slot.
//
// NOTE: ad/pixel tracking lives in `adTracking.js`. This file is about the
// customer's view of their order and has nothing to do with analytics.

export const PAYMENT_LINK = false

// Ordered list of visible client steps.
export const CLIENT_STEPS = [
  { key: 'scheduled',  label: 'Pickup scheduled' },
  { key: 'picked_up',  label: 'Picked up' },
  { key: 'progress',   label: 'In progress' },
  { key: 'back',       label: 'On the way back' },
  { key: 'delivered',  label: 'Delivered' },
]

// Map an internal status to the client step index.
export function clientStepIndex(status) {
  switch (status) {
    case 'booked':           return 0
    case 'picked_up':        return 1
    case 'processing':       return 2
    case 'out_for_delivery': return 3
    case 'delivered':        return 4
    case 'cancelled':        return -1
    default:                 return 0
  }
}

// Human label for the current step (used as page/card title).
export function clientStepLabel(status) {
  if (status === 'cancelled') return 'Cancelled'
  const i = clientStepIndex(status)
  return CLIENT_STEPS[i]?.label || CLIENT_STEPS[0].label
}

// The payment badge.
//   processing + unpaid  → gold PAYMENT DUE (with the yellow bar below the frieze)
//   processing + paid    → green PAID (bar disappears, status stays "In progress")
//   out_for_delivery, delivered + paid → green PAID (transaction closed, quiet reassurance)
// Cancelled or any earlier step: no badge.
export function paymentBadge(status, isPaid) {
  if (status === 'processing') {
    return isPaid ? { text: 'PAID', kind: 'paid' } : { text: 'PAYMENT DUE', kind: 'due' }
  }
  if ((status === 'out_for_delivery' || status === 'delivered') && isPaid) {
    return { text: 'PAID', kind: 'paid' }
  }
  return null
}
